export const headers = [
  { field: "id", headerName: "Codigo", width: 120  },
  { field: "razon_social", headerName: "Razon Social", width: 150 },
  { field: "cli_name", headerName: "Nombre de Fantasia", width: 150 },
  {
    field: "createdAt",
    headerName: "Fecha",
    width: 180,
    valueGetter: (params) => {
      const date = new Date(params.row.createdAt);
      return date.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
  },
  { field: "sel_fullname", headerName: "Vendedor", width:230 },
  { field: "totalpedido", headerName: "Total", width: 100 },
];